import React from 'react';
import StatisticsPage from '../components/supplierStats/StatisticsPage';
export default function SupplierStatsProducts() {
  return <StatisticsPage kind="brand-products" />;
}
